import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { OpenDoorService } from './service/open-door.service';

@Component({
	selector: 'app-open-door',
	templateUrl: './open-door.page.html',
	styleUrls: ['./open-door.page.scss'],
})
export class OpenDoorPage implements OnInit {
	openDoorList$: Observable<any> = this.openDoorService.fetchOpenDoorData();
	currentListStatus: any = 'pending';

	constructor(private openDoorService: OpenDoorService) {
		this.openDoorService.loadOpenDoorInit();
		this.openDoorService.loadOpenDoorAPI().subscribe();
	}

	ngOnInit() {}

	updateCompanyStatus(data: any, status: string) {
		this.openDoorService.loadOpenDoorUpdateAPI(data.id, status).subscribe();
	}

	handleChange(ev: any) {
		this.currentListStatus = ev.target.value;
		this.openDoorService.loadOpenDoorAPI(ev.target.value).subscribe();
	}

	updateStudentMeetButton(data: any, currentStatus: any) {
		this.openDoorService
			.loadOpenDoorMeetUpdateAPI(data.profileId, currentStatus.value)
			.subscribe(() => {
				// this.getJobfairSchedule(this.jobfairId);
			});
	}
}
